<template>
  <div class="grid fx_ctr h__fixed scrollable">    
    <div class="listcon mcol h__fixed spacing scroll__y">
      <Postbox :sharetxt="text" />
    </div>
    <div class="stage mcon h__fixed">
    </div>
  </div>
</template>

<script>
import Postbox from '@/components/Postbox.vue';

export default {
  name: 'WebShare',
  data() {
    return {
      text: ''
    }
  },
  components: {
    Postbox
  },
  created(){
    this.setParams(this.$route)
  },
  methods: {
    setParams: function(route){
      const query = route.query
      if(query.url) this.text += query.url + '\n'
      if(query.title) this.text += query.title + '\n'
      if(query.text) this.text += query.text
    }
  }
}
</script>